export enum DonationPurpose {
  'Udhiya' = 'Udhiya',
  'General Donation' = 'General Donation',
  'Al Wiam quran center' = 'Al Wiam quran center',
  'Gaza' = 'Gaza',
  'Ansar' = 'Ansar',
  'Noor Ummaty' = 'Noor Ummaty',
  'Djibouti Center' = 'Djibouti Center',
  'Daawa' = 'Daawa',
  'Zakat' = 'Zakat',
  'Masajid Ummaty' = 'Masajid Ummaty',
  'Water For All' = 'Water For All',
  'Ramadan Basket' = 'Ramadan Basket',
  'Feeding Hope' = 'Feeding Hope',
  'Bany Ummaty' = 'Bany Ummaty',
  'Atlas Relief' = 'Atlas Relief',
  'Zakat Al Fitr' = 'Zakat Al Fitr',
  'Iftar and Suhoor - New Muslims' = 'Iftar and Suhoor - New Muslims',
  'Ramadan Iftar' = 'Ramadan Iftar',
}

export const DEFAULT_DONATION_PURPOSE = DonationPurpose['Udhiya']

export const DonationPurposeSlugs: {[key: string]: DonationPurpose} = {
  sadaqa: DonationPurpose['General Donation'],
  'zakat-al-fitr': DonationPurpose['Zakat Al Fitr'],
  gaza: DonationPurpose['Gaza'],
  wiam: DonationPurpose['Al Wiam quran center'],
  ansar: DonationPurpose['Ansar'],
  daawa: DonationPurpose['Daawa'],
  zakat: DonationPurpose['Zakat'],
  masajid: DonationPurpose['Masajid Ummaty'],
  'djibouti-center': DonationPurpose['Djibouti Center'],
  udhiya: DonationPurpose['Udhiya'],
  water4all: DonationPurpose['Water For All'],
  ramadan: DonationPurpose['Ramadan Iftar'],
  'ramadan-iftar': DonationPurpose['Ramadan Iftar'],
  feedinghope: DonationPurpose['Feeding Hope'],
  banyummaty: DonationPurpose['Bany Ummaty'],
  atlas: DonationPurpose['Atlas Relief'],
  noor: DonationPurpose['Noor Ummaty'],
  'iftar-suhoor-new-muslims': DonationPurpose['Iftar and Suhoor - New Muslims'],
}

export const DISABLED_DONATION_PURPOSES = [
  DonationPurpose['Djibouti Center'],
  DonationPurpose['Ramadan Basket'],
  DonationPurpose['Iftar and Suhoor - New Muslims'],
  DonationPurpose['Ramadan Iftar'],
  DonationPurpose['Zakat Al Fitr'],
]

export enum DonationType {
  'Monthly' = 'Monthly',
  'One Time' = 'One Time',
}
export enum WaterForAllDonationType {
  'Build Your Own Well' = 'Build Your Own Well',
}
export enum UdhiyaDonationType {
  'Udhiya' = 'Udhiya',
}
export enum RamadanBasketDonationType {
  'Family Basket' = 'Family Basket',
}
export enum RamadanIftarDonationType {
  'Iftar Meal' = 'Iftar Meal',
}
export enum AtlasBasketDonationType {
  'Atlas Basket' = 'Atlas Basket',
}
export enum NoorBasketDonationType {
  'Noor Ummaty' = 'Noor Ummaty',
}
export enum IftarSuhoorDonationType {
  'Iftar and Suhoor - New Muslims' = 'Iftar and Suhoor - New Muslims',
}

export const AllDonationType = {
  ...DonationType,
  ...WaterForAllDonationType,
  ...UdhiyaDonationType,
  ...RamadanBasketDonationType,
  ...RamadanIftarDonationType,
  ...AtlasBasketDonationType,
  ...NoorBasketDonationType,
  ...IftarSuhoorDonationType,
}

export type AllDonationType =
  | DonationType
  | WaterForAllDonationType
  | UdhiyaDonationType
  | RamadanBasketDonationType
  | RamadanIftarDonationType
  | AtlasBasketDonationType
  | NoorBasketDonationType
  | IftarSuhoorDonationType

export const DISABLE_ONE_TIME_FOR = [
  DonationPurpose.Udhiya,
  DonationPurpose['Ramadan Iftar'],
  DonationPurpose['Noor Ummaty'],
  DonationPurpose['Iftar and Suhoor - New Muslims'],
]
export const DISABLE_MONTHLY_FOR = [
  DonationPurpose['Gaza'],
  DonationPurpose.Zakat,
  DonationPurpose.Udhiya,
  DonationPurpose['Iftar and Suhoor - New Muslims'],
  DonationPurpose['Djibouti Center'],
  DonationPurpose['Zakat Al Fitr'],
  DonationPurpose['Ramadan Basket'],
  DonationPurpose['Ramadan Iftar'],
  DonationPurpose['Atlas Relief'],
  DonationPurpose['Noor Ummaty'],
]
export const DISABLE_AMOUNTS_FOR = [
  DonationPurpose.Zakat,
  DonationPurpose['Zakat Al Fitr'],
  DonationPurpose['Noor Ummaty'],
  DonationPurpose['Iftar and Suhoor - New Muslims'],
]

export type MonthlyAmount = 40 | 80 | 150 | 200
export const MONTHLY_AMOUNTS: MonthlyAmount[] = [40, 80, 150, 200]
export type OneTimeAmount = 80 | 150 | 250 | 300
export const ONE_TIME_AMOUNTS: OneTimeAmount[] = [80, 150, 250, 300]

export const getAmounts = (donationType: AllDonationType): number[] => {
  switch (donationType) {
    case DonationType.Monthly:
      return MONTHLY_AMOUNTS

    case DonationType['One Time']:
      return ONE_TIME_AMOUNTS

    default:
      return []
  }
}

export enum UserFieldName {
  'firstName' = 'firstName',
  'lastName' = 'firstName',
  'email' = 'email',
}
export type UserFieldNameKey = keyof typeof UserFieldName

export type UserInfo = {[key in UserFieldNameKey]: string}

export const userFields: Array<{
  name: UserFieldNameKey
  label: string
  autoComplete: string
  span?: number
  type?: string
}> = [
  {
    name: 'firstName',
    label: 'First Name',
    autoComplete: 'given-name',
  },
  {
    name: 'lastName',
    label: 'Last Name',
    autoComplete: 'family-name',
  },
  {
    name: 'email',
    label: 'Email',
    autoComplete: 'email',
    span: 2,
    type: 'email',
  },
]

export type PaymentMethod = {
  Icon: React.FC<{
    className?: string | undefined
  }>
  label: string
  methodName: 'stripe' | 'payPal'
}

export enum BuildYourOwnWellType {
  Surface = 'surface',
  Deep = 'deep',
}

export enum BuildYourOwnWellPumpType {
  Manual = 'manual',
  ManualAndWaterTank = 'manual_and_water_tank',
  ManualForOneFamily = 'manual_for_one_family',
  Electric = 'electric',
  ElectricPumpAndWaterTank = 'electric_pump_and_water_tank',
}

export type BuildYourOwnWellItem = {
  country: string
  well_type: BuildYourOwnWellType
  well_pump: BuildYourOwnWellPumpType
  well_desc: string
  unit_price: number
  disabled?: boolean
}

export type BuildYourOwnWellMetadata = {
  type: 'Build your own well'
  quantity: 1
  name_on_well: string
} & BuildYourOwnWellItem

export type UdhiyaMetadata = {
  type: 'Udhiya'
  country: string
  unit_price: number
  quantity: 1
  sacrifice: string
  extra?: string
  subtitle?: string
  name?: string
  arabic_name?: string
  disabled?: boolean
}

export type FamilyBasketMetadata = {
  type: 'Family basket'
  country?: string
  unit_price: number
  quantity: number
}

export type Metadata =
  | BuildYourOwnWellMetadata
  | UdhiyaMetadata
  | FamilyBasketMetadata

export const MINIMAL_DONATION_AMOUNT = 1

const donationTypeArray = Object.keys(DonationType)
const waterForAllDonationTypeArray = Object.keys(WaterForAllDonationType)
const udhiyaDonationTypeArray = Object.keys(UdhiyaDonationType)
const ramadanBasketDonationTypeArray = Object.keys(RamadanBasketDonationType)
const ramadanIftarDonationTypeArray = Object.keys(RamadanIftarDonationType)
const atlasBasketDonationTypeArray = Object.keys(AtlasBasketDonationType)
const noorBasketDonationTypeArray = Object.keys(NoorBasketDonationType)
const iftarSuhoorDonationTypeArray = Object.keys(IftarSuhoorDonationType)

export const getDonationTypes = (
  donationPurpose: DonationPurpose,
): string[] => {
  let modifiedDonationTypeArray = donationTypeArray.slice()
  if (DISABLE_ONE_TIME_FOR.includes(donationPurpose)) {
    modifiedDonationTypeArray = modifiedDonationTypeArray.filter(
      (donationType) => donationType !== DonationType['One Time'],
    )
  }
  if (DISABLE_MONTHLY_FOR.includes(donationPurpose)) {
    modifiedDonationTypeArray = modifiedDonationTypeArray.filter(
      (donationType) => donationType !== DonationType.Monthly,
    )
  }
  switch (donationPurpose) {
    case DonationPurpose['Water For All']:
      modifiedDonationTypeArray = modifiedDonationTypeArray.concat(
        waterForAllDonationTypeArray,
      )
      break
    // @ts-ignore We don't care, it is only because we disabled it
    case DonationPurpose.Udhiya:
      modifiedDonationTypeArray = modifiedDonationTypeArray.concat(
        udhiyaDonationTypeArray,
      )
      break
    // @ts-ignore We don't care, it is only because we disabled it
    case DonationPurpose['Ramadan Basket']:
      modifiedDonationTypeArray = modifiedDonationTypeArray.concat(
        ramadanBasketDonationTypeArray,
      )
      break
    case DonationPurpose['Ramadan Iftar']:
      modifiedDonationTypeArray = modifiedDonationTypeArray.concat(
        ramadanIftarDonationTypeArray,
      )
      break
    case DonationPurpose['Atlas Relief']:
      modifiedDonationTypeArray = modifiedDonationTypeArray.concat(
        atlasBasketDonationTypeArray,
      )
      break
    case DonationPurpose['Noor Ummaty']:
      modifiedDonationTypeArray = modifiedDonationTypeArray.concat(
        noorBasketDonationTypeArray,
      )
      break
    case DonationPurpose['Iftar and Suhoor - New Muslims']:
      modifiedDonationTypeArray = modifiedDonationTypeArray.concat(
        iftarSuhoorDonationTypeArray,
      )
      break
  }
  return modifiedDonationTypeArray
}
